import { useEffect, useState, useRef } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useIntl, FormattedMessage, defineMessages } from 'react-intl';
import { Container, Button, Dropdown, Modal } from 'semantic-ui-react';
import { BodyClass, flattenToAppURL } from '@plone/volto/helpers';
import Anontools from '@plone/volto/components/theme/Anontools/Anontools'; 
import Logo from '@plone/volto/components/theme/Logo/Logo';
import Navigation from '@plone/volto/components/theme/Navigation/Navigation';
import SearchWidget from '@plone/volto/components/theme/SearchWidget/SearchWidget';
import PropTypes from 'prop-types';
import { map } from 'lodash';
import { getHeaderInfo } from '../../actions';
import { getView } from '../../helpers';
import { Announcements, GoogleTranslateSelector, HeaderMinisite, CustomColor, A11Y } from './';

import imgHeader from './img/default-bg.jpg';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMessage, faMagnifyingGlass, faXmark, faBars } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faXTwitter, faWhatsapp, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
const socialIcons = {
  facebook: faFacebookF,
  twitter: faXTwitter,
  youtube: faYoutube,
  whatsapp: faWhatsapp,
  instagram: faInstagram
}


const messages = defineMessages({
  xxss: {
    id: 'Our social networks',
    defaultMessage: 'Our social networks',
  },
});


const Header = ({ pathname }) => {
  const location = useLocation();
  const intl = useIntl();
  const view = getView(location.pathname);
  const customRoot = useSelector((state) => state.navroot.data?.custom_root);

  const headerImage = useSelector((state) => state?.header_info?.header_info?.header_image);
  const headerImageSrc = headerImage && headerImage.image_field !== 'none' && headerImage['@id']
    ? `${flattenToAppURL(headerImage['@id'])}/@@images/${headerImage.image_field}/slide`
    : null;

  const navroot = useSelector((state) => state.navroot.data);
  const actualPathname = useLocation().pathname;
  const navRootPath = flattenToAppURL(navroot?.navroot?.['@id']) || '/';
  const currentURLIsNavRoot = actualPathname === navRootPath;

  const inputRef = useRef(null);

  const { socialActions = [] } = useSelector(
    (state) => ({
      socialActions: state.actions?.actions?.social_actions,
    }),
    shallowEqual,
  );

  const getShowMinisiteHeader = () => {
    if (customRoot?.['@type'] === 'Minisite' && view == 'view')
        return true
    return false
  }
  const showMinisiteHeader = getShowMinisiteHeader()
  const [booShowNavMinisite, setShowNavMinisite] = useState(false);

  const handleShowNavMinisiteClick = () => {
    setShowNavMinisite(!booShowNavMinisite);
  }

  useEffect(() => {

    // Change header when the user scrolls the page
    var scrollDistance = function (callback, refresh) {
      // Make sure a valid callback was provided
      if (!callback || typeof callback !== 'function') return;
      // Variables
      var isScrolling, start, end, distance;
      start = 0;
      // Listen for scroll events
      window.addEventListener('scroll', function (event) {         
        // Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling);
        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(function() {
          // Calculate distance
          end = window.scrollY;
          distance = end - start;
          // Run the callback
          callback(distance, start, end);
          // Reset calculations
          end = null;
          distance = null;
        }, refresh || 66);
      }, false);

    };

    // Add affix class on page load if necessary
    window.addEventListener('load', function(event) {
      if ( window.scrollY > (theHeader.offsetHeight + 16) ) {
        document.getElementById('portal-header').classList.add('affix');
      } else {
        document.getElementById('portal-header').classList.remove('affix');       
      }
    }); 
    var theHeader = document.getElementById('portal-header');
    scrollDistance(function (distance) {
      if ( distance > (theHeader.offsetHeight + 16) ) {
        document.getElementById('portal-header').classList.add('affix');
      } else {
        document.getElementById('portal-header').classList.remove('affix');       
      }
    });

  }, []);

  // Get current day
  const today = new Date();
  const monthDay = today. getDate();

  // Show search modal
  const [open, setOpen] = useState(false)
  useEffect(() => {
    setOpen(false);
  }, [location]);


  // Show hide main menu in minisite
  const [isMinisiteMainMenuOpen, setMainMenuMinisiteOpen] = useState(false);
  const toggleMainMenuMinisite = () => {
    setMainMenuMinisiteOpen(!isMinisiteMainMenuOpen);
  };

  return (
    <>
      <BodyClass className={ booShowNavMinisite ? 'showNavMinisite' : ''} />

      <CustomColor />

      <header >

        { /* Announcements only on frontpage */
          currentURLIsNavRoot &&
          <Announcements />
        }

        <div id="portal-header" 
          className="header-wrapper"
          data-spy="affix" 
          data-offset-top="144" >
            
          <div className="topBar">

            {/* A11Y */} 
            <A11Y />

            {/* SNS */}
            {socialActions?.length > 0 &&
              <Button.Group className='XXSS d-none d-lg-inline-flex ms-lg-3' basic aria-label={intl.formatMessage(messages.xxss)} >
                {map(socialActions, (item) => (
                  <Button as="a" basic className="XXSS__link  topBar__btn" href={item.url} key={item.id} target="_blank" rel="noopener noreferrer" >
                    <FontAwesomeIcon icon={socialIcons[item.id]} className='XXSS__icon' />
                    <span className="visually-hidden">{item?.title}</span>
                  </Button>
                ))}
              </Button.Group>
            }

            <GoogleTranslateSelector />

            <Button.Group className='ms-auto ms-md-3'>
              {/* Appoinments */}
              <Button className='btnCita topBar__btn' as='a' href="https://citaprevia.palafolls.cat/" >
                <span className="btnCita__icon" aria-hidden="true">{monthDay}</span>
                <span className="visually-hidden-xs"><FormattedMessage id="Cita prèvia" defaultMessage="Cita prèvia" /></span>
              </Button>

              {/* Contact */}
              <Button className='btnContact topBar__btn' as='a' href={`${flattenToAppURL(customRoot?.['@id'])}/contacte`} >
                <FontAwesomeIcon icon={faMessage} />
                <span className="visually-hidden-xs"><FormattedMessage id="Contacte" defaultMessage="Contacte" /></span>
              </Button>
            </Button.Group>

          </div>
          
        <Container className="portalHeader">

          <figure className="portalLogo">
            <Logo />
          </figure>

          <div className="centerBar d-flex align-items-center justify-content-end">

            <Navigation pathname={pathname} />

            {/* Search */}
            <Modal
              closeIcon={<Button basic className='searchToggle'><FontAwesomeIcon icon={faXmark} /><span className='visually-hidden'><FormattedMessage id="Close" defaultMessage="Close" /></span></Button>}
              open={open}
              trigger={<Button basic className='searchToggle d-print-none'><FontAwesomeIcon icon={faMagnifyingGlass} /><span className="visually-hidden">Cercar</span></Button>}
              onClose={() => setOpen(false)}
              onOpen={() => {setOpen(true); setTimeout(() => {inputRef.current?.focus();}, 0);}}
            >
              <SearchWidget inputRef={inputRef} />
            </Modal>

          </div>

        </Container>
        </div>
        <div className="affixFixer"></div>

        {showMinisiteHeader && (
          <>
            {/* MINISITE HEADER */}
            <BodyClass className='minisiteTree' />
            <HeaderMinisite />
          </>
        )}

      {/* Inner header */}
      {!currentURLIsNavRoot &&
        <div className='imgInnerHeader__wrapper d-print-none'>
          {(headerImage?.image_field && headerImage?.image_field != 'none') ? (
            <img src={headerImageSrc} alt="" className='imgInnerHeader' sizes="100vw" />
          ) : (
            <img src={imgHeader} alt="" className='imgInnerHeader' sizes="100vw" />
          )}
        </div>
      }
      </header>
    </>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};
